export const paths = {
  any: '*',
  dashboard: '/dashboard',
  organizations: {
    root: '/organizations',
    details: {
      root: '/organizations/:organizationId',
      tab: '/organizations/:organizationId/:tab',
      vendors: '/organizations/:organizationId/vendors/:vendorId',
      vendorsTab: {
        root: '/organizations/:organizationId/vendors/:vendorId/:subTab',
        children: {
          details: ':vendorId/:subTab',
        },
      },
      work: {
        actionItems: '/organizations/:organizationId/work/action-items',
        tickets: {
          root: '/organizations/:organizationId/work/tickets',
          any: '/organizations/:organizationId/work/tickets/*',
          new: '/organizations/:organizationId/work/tickets/new',
          details: '/organizations/:organizationId/work/tickets/:ticketId',
          edit: '/organizations/:organizationId/work/tickets/:ticketId/edit',
          comments:
            '/organizations/:organizationId/work/tickets/:ticketId/comments',
          commentsNew:
            '/organizations/:organizationId/work/tickets/:ticketId/comments/new',
          relatedTasks:
            '/organizations/:organizationId/work/tickets/:ticketId/related-tasks',
          relatedTasksNew:
            '/organizations/:organizationId/work/tickets/:ticketId/related-tasks/new',
          activityLog:
            '/organizations/:organizationId/work/tickets/:ticketId/activity-log',
        },
        tasks: {
          root: '/organizations/:organizationId/work/tasks',
          any: '/organizations/:organizationId/work/tasks/*',
          new: '/organizations/:organizationId/work/tasks/new',
          details: '/organizations/:organizationId/work/tasks/:taskId',
          edit: '/organizations/:organizationId/work/tasks/:taskId/edit',
          subtasks: {
            root: '/organizations/:organizationId/work/tasks/:taskId/subtasks',
            new: '/organizations/:organizationId/work/tasks/:taskId/subtasks/new',
          },
        },
      },
      auditDetails: '/organizations/:organizationId/audits/:auditId',
      auditNegotiationsVendors: {
        attach:
          '/organizations/:organizationId/audits/:auditId/negotiations/vendors/attach',
        new: '/organizations/:organizationId/audits/:auditId/negotiations/vendors/new',
      },
      auditDocuments: {
        attach:
          '/organizations/:organizationId/audits/:auditId/documents/attach',
      },
      auditSpendEstimated: {
        vendorAccountsAttach:
          '/organizations/:organizationId/audits/:auditId/spend-estimated/vendor-accounts/attach',
        vendorAccountsNew:
          '/organizations/:organizationId/audits/:auditId/spend-estimated/vendor-accounts/new',
        spendsNew:
          '/organizations/:organizationId/audits/:auditId/spend-estimated/spends/new',
        spendsImport:
          '/organizations/:organizationId/audits/:auditId/spend-estimated/spends/import',
      },
      documentsPreview:
        '/organizations/:organizationId/documents/preview/:documentId',
      documentsViewer:
        '/organizations/:organizationId/documents/document/:documentId',
    },
  },
  projects: {
    root: '/projects',
    new: '/projects/new',
    details: {
      root: '/projects/:projectId',
      tab: '/projects/:projectId/:tab',
      tickets: {
        root: '/projects/:projectId/tickets',
        any: '/projects/:projectId/tickets/*',
        new: '/projects/:projectId/tickets/new',
        details: '/projects/:projectId/tickets/:ticketId',
        edit: '/projects/:projectId/tickets/:ticketId/edit',
        comments: '/projects/:projectId/tickets/:ticketId/comments',
        commentsNew: '/projects/:projectId/tickets/:ticketId/comments/new',
        relatedTasks: '/projects/:projectId/tickets/:ticketId/related-tasks',
        relatedTasksNew:
          '/projects/:projectId/tickets/:ticketId/related-tasks/new',
        activityLog: '/projects/:projectId/tickets/:ticketId/activity-log',
      },
    },
    children: {
      details: ':projectId',
    },
  },
  vendors: {
    root: '/vendors',
    details: {
      root: '/vendors/:vendorId',
      tab: '/vendors/:vendorId/:tab',
      tickets: {
        root: '/vendors/:vendorId/tickets',
        any: '/vendors/:vendorId/tickets/*',
        new: '/vendors/:vendorId/tickets/new',
        details: '/vendors/:vendorId/tickets/:ticketId',
        edit: '/vendors/:vendorId/tickets/:ticketId/edit',
        comments: '/vendors/:vendorId/tickets/:ticketId/comments',
        commentsNew: '/vendors/:vendorId/tickets/:ticketId/comments/new',
        relatedTasks: '/vendors/:vendorId/tickets/:ticketId/related-tasks',
        relatedTasksNew:
          '/vendors/:vendorId/tickets/:ticketId/related-tasks/new',
        activityLog: '/vendors/:vendorId/tickets/:ticketId/activity-log',
      },
    },
  },
  login: '/login',
  redirect: '/redirect',
  storybook: '/storybook',
} as const;

export type TicketRoutePaths =
  | typeof paths.organizations.details.work.tickets
  | typeof paths.projects.details.tickets
  | typeof paths.vendors.details.tickets;
